import { render, staticRenderFns } from "./SupplierChangesPrompt.vue?vue&type=template&id=8fef01aa"
import script from "./SupplierChangesPrompt.vue?vue&type=script&lang=js"
export * from "./SupplierChangesPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports